// Makes a floating panel draggable by a given handle. Panel position is
// pinned in pixel coordinates on first drag; subsequent opens stay where
// the user last left it. Suppresses drag when the pointer lands on an
// element marked `data-no-drag` (e.g. close/minimize buttons).

export function enableDrag({ panelId, handleId }) {
  const head = document.getElementById(handleId);
  const box = document.getElementById(panelId);
  if (!head || !box) return;

  let dragging = false;
  let startX = 0;
  let startY = 0;
  let startLeft = 0;
  let startTop = 0;

  head.addEventListener('pointerdown', (e) => {
    if (e.target.closest('[data-no-drag]')) return;
    dragging = true;
    const rect = box.getBoundingClientRect();
    startX = e.clientX;
    startY = e.clientY;
    startLeft = rect.left;
    startTop = rect.top;
    box.style.left = rect.left + 'px';
    box.style.top = rect.top + 'px';
    box.style.right = 'auto';
    box.style.bottom = 'auto';
    head.setPointerCapture(e.pointerId);
  });

  head.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    const dx = e.clientX - startX;
    const dy = e.clientY - startY;
    const rect = box.getBoundingClientRect();
    const maxLeft = window.innerWidth - rect.width;
    const maxTop = window.innerHeight - 40;
    box.style.left = Math.max(0, Math.min(maxLeft, startLeft + dx)) + 'px';
    box.style.top = Math.max(0, Math.min(maxTop, startTop + dy)) + 'px';
  });

  const endDrag = (e) => {
    if (!dragging) return;
    dragging = false;
    try {
      head.releasePointerCapture(e.pointerId);
    } catch {}
  };
  head.addEventListener('pointerup', endDrag);
  head.addEventListener('pointercancel', endDrag);
}
